import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";

/**
 * Properly delete a clusterer
 */
export function destroyMarkerClusterer(clusterer: MarkerClusterer | null) {
    if (!clusterer) return;
    clusterer.clearMarkers();
    clusterer.setMap(null);
}

/**
 * Create a cluster only if there are at least two markers
 */
export function createMarkerClusterer(
    map: google.maps.Map,
    markers: google.maps.Marker[]
): MarkerClusterer | null {
    if (!markers || markers.length < 2) return null;

    const svg = window.btoa(`<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" fill="white"/> <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" stroke="#D8592E"/> </svg>`);

    const renderer = {
        render: ({ count, position }: { count: number; position: google.maps.LatLng }) =>
            new google.maps.Marker({
                position,
                label: {
                    text: String(count),
                    color: "#D8592E",
                    fontSize: "16px",
                    fontWeight: "600",
                },
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(56, 56),
                },
            }),
    };

    const algorithm = new GridAlgorithm({ gridSize: 55 });

    return new MarkerClusterer({ map, markers, renderer, algorithm });
}
